<template>
  <div class="centered">
    <div class="Step-2">{{ $t('decrypt.title') }}</div>
    <alert v-if="snackbar" :errorMsg="errorMsg" />

    <v-flex>
      <p class="select">{{ $t('decrypt.data') }}</p>

      <v-textarea
        outline
        name="dataEncrypted"
        :value="this.$store.getters.state.dataIdentityIdEncrypted"
        color="#01a3b0"
        class="data"
        readonly
        no-resize
      ></v-textarea>
    </v-flex>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { decompressData } from '@/wallid/new_compress';
const WALLID = 'WALLID';
export default {
  name: 'Decrypt',

  computed: {
    ...mapGetters(['step']),

    snackbar: {
      get() {
        return this.$store.state.snackbar;
      },
      set(newValue) {
        return this.$store.commit('snackbar', newValue);
      },
    },
    errorMsg: {
      get() {
        return this.$store.state.errorMsg;
      },
      set(newValue) {
        return this.$store.commit('errorMsg', newValue);
      },
    },
  },
  methods: {
    submitStep: async function() {
      var loadData = [];
      var identityID = {};
      var verifyID = {};
      try {
        if (this.isPluginInstalled() == WALLID) {
          await window
            .wallid(
              'wallet_decrypt',
              decompressData(this.$store.state.dataIdentityIdEncrypted)
            )
            .then((res) => {
              console.log(res);
              identityID = res;
              this.confirmTx = true;
            })
            .catch((err) => {
              console.error(err);
              return;
            });

          await window
            .wallid(
              'wallet_decrypt',
              decompressData(this.$store.getters.state.dataVerifyIdEncrypted)
            )
            .then((res) => {
              console.log(res);
              verifyID = res;
              this.confirmTx = true;
            })
            .catch((err) => {
              console.error(err);
              return;
            });
        } else {
          identityID = decompressData(
            this.$store.state.dataIdentityIdEncrypted
          );

          verifyID = decompressData(
            this.$store.getters.state.dataVerifyIdEncrypted
          );
        }

        this.$store.commit('dataIdentityId', identityID);
        this.$store.commit('dataVerifyId', verifyID);

        for (var i in identityID.identityAttributes) {
          loadData.push({ item: i, value: identityID.identityAttributes[i] });
        }

        this.$store.commit('data', loadData);
        this.$store.commit('loading', false);
        this.$store.commit('step', 2);

        this.$eventHub.$emit('eventUpdate', {
          time: 1,
          params: {
            msg: this.$i18n.t('intercom.sign'),
          },
        });
      } catch (err) {
        console.log('error', err);
        this.errorMsg = 'revoked';
        // this.snackbar = true;
        this.$eventHub.$emit('eventUpdate', {
          time: 1,
          params: {
            msg: this.$i18n.t('intercom.button'),
          },
        });
      }
    },

    backStep: function() {
      this.$store.commit('decStep');
      if (this.$store.getters.step === 0) {
        this.$router.push('/');
      } else if (this.$store.getters.step === 1) {
        this.$store.commit('idt', '');
        this.$store.commit('loading', false);
        this.$store.commit('idt', '');
      }
    },
    cancelSign: function() {
      this.$store.commit('idt', '');
      this.$router.push('/');
    },
  },
  data() {
    return {
      show: false,
    };
  },
};
</script>

<style scoped>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  padding-left: 0px;
}
.v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
  margin-top: 9px;

  width: 700px;
  height: 86px;
  font-family: 'Montserrat';
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.77;
  letter-spacing: normal;
  color: #035b60;
}

.v-text-field--box.v-text-field--single-line input,
.v-text-field--full-width.v-text-field--single-line input,
.v-text-field--outline.v-text-field--single-line input {
  margin-top: 14px;
  margin-bottom: 17px;
  font-family: 'Montserrat';
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.44;
  letter-spacing: normal;
  color: #035b60;
}
/* textarea scroll bar */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 0 rgba(0, 0, 0, 0.3);
  box-shadow: inset 0 0 0 rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: rotate3d(0, 0, 0, 0);
  transform: rotate3d(0, 0, 0, 0);
  -webkit-transition: background-color 100ms ease-out, margin 100ms ease-out,
    height 100ms ease-out;
  transition: background-color 100ms ease-out, margin 100ms ease-out,
    height 100ms ease-out;
  background-color: #d8d8d8;
  margin: 5px 5px 5px 0px;
  border-radius: 4px;
  height: calc(100% - 10px);
  display: block;
}
/* passwaord field */

.theme--light.v-input:not(.v-input--is-disabled) input,
.theme--light.v-input:not(.v-input--is-disabled) textarea {
  margin-top: 2px;
  margin-bottom: 2px;
  color: #035b60;
  display: block;
}

.theme--light.passfield.v-text-field--outline
  > .v-input__control
  > .v-input__slot {
  border-radius: 4px;
  border: solid 1px #d8d8d8;
  padding-right: 22px;
  max-height: 42px;
  width: 425px;
}

.theme--light.passfield.error--text.v-text-field--outline
  > .v-input__control
  > .v-input__slot {
  border: solid 1px #d0021b;
}

.v-text-field.error--text.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot:hover {
  border-radius: 2px;
  border: solid 1px #d0021b;
}
.theme--light.v-text-field--outline > .v-input__control > .v-input__slot {
  border-radius: 4px;
  border: solid 1px #d8d8d8;
  padding-right: 22px;
}

.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  -webkit-box-shadow: 0px 0px 0px 0px rgb(255, 255, 255),
    0px 0px 0px 0px rgb(255, 255, 255), 0px 0px 0px 0px rgb(255, 255, 255);
  box-shadow: 0px 0px 0px 0px rgb(255, 255, 255),
    0px 0px 0px 0px rgb(255, 255, 255), 0px 0px 0px 0px rgb(255, 255, 255);
}
.el1 {
  max-height: 100%;
}

.vuebar-element {
  height: 100%;
  width: 100%;
  max-width: 898px;
}

.vb > .vb-dragger {
  z-index: 5;
  width: 12px;
  right: 21px;
}

.vb > .vb-dragger > .vb-dragger-styler {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: rotate3d(0, 0, 0, 0);
  transform: rotate3d(0, 0, 0, 0);
  -webkit-transition: background-color 100ms ease-out, margin 100ms ease-out,
    height 100ms ease-out;
  transition: background-color 100ms ease-out, margin 100ms ease-out,
    height 100ms ease-out;
  background-color: #d8d8d8;
  margin: 5px 5px 5px 0px;
  border-radius: 4px;
  height: calc(100% - 10px);
  display: block;
}

.vb.vb-scrolling-phantom > .vb-dragger > .vb-dragger-styler {
  background-color: #d8d8d8;
}

.vb > .vb-dragger:hover > .vb-dragger-styler {
  background-color: #d8d8d8;
  margin: 0px;
  height: 100%;
}

.vb.vb-dragging > .vb-dragger > .vb-dragger-styler {
  background-color: #d8d8d8;
  margin: 0px;
  height: 100%;
}

.vb.vb-dragging-phantom > .vb-dragger > .vb-dragger-styler {
  background-color: #d8d8d8;
}

.v-input--selection-controls .v-input__control {
  height: 24px;
}

.disclaimer {
  display: block;
  font-family: 'Montserrat';
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.57;
  letter-spacing: normal;
  color: #035b60;
}
</style>

<style scoped>
.passfield {
  margin-top: 12px;
  margin-bottom: 12px;
}

.data {
  margin-right: 0px;
  max-width: 832px;
  font-family: 'Montserrat';
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.77;
  letter-spacing: normal;
  color: #035b60;
}

.back {
  margin-right: 0px;
  margin-left: 16px;
  width: 109px;
  height: 36px;
  border-radius: 2px;
  border: solid 1px #035b60;

  font-family: 'Montserrat';
  font-size: 15px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.6;
  letter-spacing: normal;
  text-align: center;
  color: #035b60;
}

.v-stepper__label {
  font-family: 'Montserrat';
  font-size: 13px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.54;
  letter-spacing: normal;
  color: #01a3b0;
}

.encrypted {
  width: 827px;
  height: 48px;
  font-family: 'Montserrat';
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: #035b60;
}
.Step-2 {
  margin-top: 0px;
  margin-bottom: 24px;
  width: 608px;
  height: 24px;
  font-family: 'Montserrat';
  font-size: 20px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.2;
  letter-spacing: normal;
  color: #035b60;
  text-align: left;
}

.welcome {
  font-family: 'Montserrat', sans-serif;
  font-size: 20px;
  height: 24px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.2;
  letter-spacing: normal;
  color: #035b60;
  text-align: left;
}
.select {
  margin-top: 36px;
  margin-bottom: 12px;

  font-family: 'Montserrat';
  font-size: 15px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.6;
  letter-spacing: normal;
  color: #035b60;
}
</style>
